module.exports = __webpack_public_path__ + "img/cancel-flow-home-hero.0dd21548.svg";